import React from 'react';
import Icon from '../../../components/AppIcon';

const BrandingHeader = () => {
  return (
    <div className="text-center mb-8 md:mb-10">
      <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-5 md:mb-6 rounded-[16px] bg-gradient-to-br from-primary/20 to-accent/20 flex items-center justify-center shadow-glow-primary transition-smooth hover:scale-105">
        <Icon name="Vault" size={48} color="var(--color-primary)" className="md:w-14 md:h-14" />
      </div>
      
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold text-foreground mb-3 md:mb-4">
        Welcome to TheVault
      </h1>
      
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-md mx-auto px-4">
        Premium trading bot management dashboard for sophisticated algorithmic trading professionals
      </p>
    </div>
  );
};

export default BrandingHeader;